module.exports = __webpack_public_path__ + "media/images/ping/ping_rojo-dfb34b456c083c541e20d8460897656c.png";